import { FunctionComponent } from "react";

import {
  button,
  icon,
} from "@ui/components/article/ShareButtons/ShareButtons.css";
import RssSocialIcon from "@ui/components/icon/RSSIcon";
import { ArticleLayout } from "@ui/components/ledes/ledes.types";

interface Props {
  url: string;
  layout: ArticleLayout | "stream" | "video";
}

const ShareButtonsFacebook: FunctionComponent<Props> = ({ url, layout }) => {
  return (
    <a aria-label="Open RSS feed" href={url} className={button[layout]}>
      <RssSocialIcon className={icon[layout]} />
    </a>
  );
};

export default ShareButtonsFacebook;
